<template>
    <div>
        <el-card>
        <div class="dashboard-header">
            <div class="left-header">
                <h1>This Month</h1>
            </div>
            <!-- eo left header -->

            <div class="right-dates">
                <h1><span class="month">sept</span></h1>
            </div>
            <!-- eo right dates -->
        </div>

        <div class="dashboard-content">
            
            <div class="graph">
                <kendo-chart ref="chart"
                            :legend-position="'bottom'"
                            :chart-area-background="''"
                            :chart-area-height="'248px'"
                            :series-defaults-type="'line'"
                            :series-defaults-style="'smooth'"
                            :value-axis-labels-format="'{0}'"
                            :value-axis-line-visible="false"
                            :value-axis-axis-crossing-value="'-10'"
                            :category-axis-categories="categories"
                            :category-axis-major-grid-lines-visible="false"
                            :category-axis-labels-rotation="'auto'"
                            :tooltip-visible="true"
                            :tooltip-format="'{0}'"
                            :tooltip-template="tooltiptemplate"
                            :theme="'sass'">
                    <kendo-chart-series-item :name="'Missed Calls'" :data="monthlyMissedCallData"></kendo-chart-series-item>
                </kendo-chart>
            </div>
            <!-- eo dashboard graph -->

            <div class="dashboard-detail">
                
                <div class="dashboard-box total-missedcall">
                    <h1>126</h1>
                    <p>Missed calls</p>
                </div>

                <div class="dashboard-box returning-customers">
                    <h1>126</h1>
                    <p>Missed calls</p>
                </div>
            </div>
        </div>
        </el-card>
    </div>
</template>


<script>

export default {
    data: function() {
        return {
            tooltiptemplate: '#= series.name #: #= value #',
            monthlyMissedCallData: [200, 500, 300, 100, 200],
            categories: ["1st week", "2nd week", "3rd week", "4th week", "5th week"]
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/views/parts/dashboardmonth.vue